export class clientTop {
    fieldsDefault = [{ index: 1, value: '' }, { index: 2, value: '' }, { index: 3, value: '' }, {
        index: 4,
        value: '',
    }, { index: 5, value: '' }, { index: 6, value: '' }]
    fieldsCanvas = {}
    arrListCategory = [
        { id: 0, name: 'Face', nameSave: 'List-Modal-Face', fields: this.fieldsDefault },
        { id: 1, name: 'Tooth', nameSave: 'List-Modal-Tooth', fields: this.fieldsDefault },
        { id: 2, name: 'Aligner', nameSave: 'List-Modal-Aligner', fields: this.fieldsDefault },
        { id: 3, name: 'X-ray', nameSave: 'List-Modal-X-ray', fields: this.fieldsDefault },
        { id: 4, name: 'Other', nameSave: 'List-Modal-Other', fields: this.fieldsDefault },
        { id: 4, name: 'SmileFlame', nameSave: 'List-Modal-Smile', fields: this.fieldsCanvas },
        { id: 4, name: 'SmileDesign', nameSave: 'List-Modal-Dsd', fields: this.fieldsCanvas },
    ]
}



// WEBPACK FOOTER //
// ./src/models/clientTop.ts